<template>
  <filter-button
    :active="active"
    action="simulations/filter"
  />
</template>

<script>
  import { mapState } from 'vuex';

  import FilterButton from '@sdk/components/Filters/Button.vue';

  export default {
    name: 'SimulationsListFilter',
    components: {
      FilterButton,
    },
    computed: {
      ...mapState([
        'simulations',
      ]),

      active() {
        // eslint-disable-next-line no-underscore-dangle
        return this.simulations.list.filters._active;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .simulations-approved-filter {
  }
</style>
